<template>
  <div class="home">
    <div class="images">
      <loopPlayImages
        v-if="bannerImagesData != null"
        :images-data="bannerImagesData"
        :background-appe-mode="false"
        :default-classes="loopPlayImagesData.defaultClasses"
      ></loopPlayImages>
    </div>
    <!-- <div class="Hot_list">
      <div class="title">正在热播</div>
      <ul>
        <li class="select">中国中医药大会</li>
        <li>地球最后的夜晚</li>
        <li>流浪地球飞跃2020特别版</li>
        <li>我的影子在奔跑</li>
        <li>不二兄弟</li>
        <li>急诊科医生</li>
        <li>锦绣缘华丽冒险 DVD版</li>
        <li>生活，这40年</li>
        <li>但是还有书籍</li>
        <li>汉字里的中国人</li>
        <li>阿浪的远方</li>
        <li>通往春天的列车</li>
      </ul>
    </div> -->
    <div class="popular_box"></div>
    <!-- <div class="popular" > -->
      <!-- <KeywordList
        :info="keyListContentData"
        @moreClick="moreClick"
        @targetChange="targetChange"
      /> -->
  
      <!-- <div class="small_title">热门推荐</div>
      <div class="substance">
        <div class="substance_left">
          <img src="../../public//img/newPages/ceshi.png" alt="" />
          <div class="bottom">
            <div class="text">
              <span>都市之修行千年</span>
              <span>短剧飙升榜第一名</span>
            </div>
            <div class="num">9.8</div>
          </div>
        </div>
        <ul class="substance_right">
          <li>
            <img src="../../public//img/newPages/ceshi.png" alt="" />
            <span>双面千金洛莞莞</span>
          </li>
          <li>
            <img src="../../public//img/newPages/ceshi.png" alt="" />
            <span>双面千金洛莞莞</span>
          </li>
          <li>
            <img src="../../public//img/newPages/ceshi.png" alt="" />
            <span>双面千金洛莞莞</span>
          </li>
          <li>
            <img src="../../public//img/newPages/ceshi.png" alt="" />
            <span>双面千金洛莞莞</span>
          </li>
          <li>
            <img src="../../public//img/newPages/ceshi.png" alt="" />
            <span>双面千金洛莞莞</span>
          </li>
          <li>
            <img src="../../public//img/newPages/ceshi.png" alt="" />
            <span>双面千金洛莞莞</span>
          </li>
          <li>
            <img src="../../public//img/newPages/ceshi.png" alt="" />
            <span>双面千金洛莞莞</span>
          </li>
          <li>
            <img src="../../public//img/newPages/ceshi.png" alt="" />
            <span>双面千金洛莞莞</span>
          </li>
        </ul>
      </div> -->
    <!-- </div> -->

    <!-- <div class="model">
      <img src="../../public/img/newPages/bg1.png" alt="" />
    </div> -->

    <div style="margin-top: 540px;"></div>

    <ImageList
      :info="item"
      @moreClick="moreContentsClick"
      @movieClick="movieClick"
      v-for="(item, i) in templateData"
      :key="i"
    />

    <div class="advertisement" v-if="bottomBanner">
      <a :href="`${bottomBanner.link}`" target="_blank">
        <img :src="bottomBanner.image" :alt="bottomBanner.title" />
      </a>
    </div>

    <div class="flotation">
      <div
        class="flotation_top"
        v-show="flotationSelect == 'WeChat' || flotationSelect == 'phone'"
      >
        <img
          src="../../public/img/newPages/weixin-1.jpg"
          alt=""
          v-if="flotationSelect == 'WeChat'"
        />
        <img
          src="https://resstatic.today365.com.cn/wstatic/static/image/qrcode.png"
          alt=""
          v-if="flotationSelect == 'phone'"
        />
        <span>瑞网微视下载</span>
      </div>
      <div class="flotation_bottom">
        <div
          :class="flotationSelect == 'WeChat' ? 'select' : ''"
          @mouseover="QRcode('WeChat')"
          @mouseleave="QRcode('none')"
        >
          <img src="../../public/img/newPages/weixin_icon.png" alt="" />
        </div>
        <div
          :class="flotationSelect == 'phone' ? 'select' : ''"
          @mouseover="QRcode('phone')"
          @mouseleave="QRcode('none')"
        >
          <img src="../../public/img/newPages/shouji_icon.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "@/utils/eventBus";
import loopPlayImages from "@/components/loopPlayImages/loopPlayImages.vue";
import "../assets/css/loopPlayImages.css";
import KeywordList from "@/components/gaoyinghao/keywordList.vue";
import Seniority from "@/components/gaoyinghao/seniority.vue";
import ImageList from "@/components/gaoyinghao/imageList.vue";
import "../assets/css/Home.css";
import $ from "jquery";

const IMAGESCONST = {
  电影: { icon: "movie_icon" },
  电视剧: { icon: "special" },
  娱乐: { icon: "recreation" },
  RMHD: { icon: "vip" },
  精品: { icon: "boutique" },
  热播: { icon: "host" },
};

export default {
  name: "home",
  components: {
    loopPlayImages,
    KeywordList,
    ImageList,
    Seniority,
  },
  mounted: function () {
    var self = this;
    bus.$emit("updateFooter", "首页");
    this.$axios({
      url: "/realNet/pageManager/findOne",
      method: "get",
      headers: {
        token: "123456789",
      },
      params: {
        title: "首页",
      },
    }).then(function (resp) {
      if (resp.data.result) {
        //轮播图区数据处理
        var dataMap = resp.data.result.dataMap;

        self.bottomBanner = dataMap.bottomBanner
          ? dataMap.bottomBanner[0]
          : null;
        if (dataMap.bannerList) {
          self.bannerImagesData = dataMap.bannerList.map((item) => {
            return {
              backgroundImage: item.image,
              imageLinkRouterName: item.link,
            };
          });
        }
        //关键字区域
        let keyListContentDataList = [];
        dataMap.menuList.forEach((item) => {
          keyListContentDataList = [
            ...keyListContentDataList,
            ...item.menuList,
          ];
        });
        self.keyListContentData = keyListContentDataList;
        //内容区数据处理
        var tempData = new Array(dataMap.contentTemplateList.length);
        var tempDataCount = 0;
        dataMap.contentTemplateList.map((item, idx) => {
          var requestParamsData = {
            orderByField: item.searchSortOrder,
            orderByType: item.searchSortOrderType,
            pageSize: 8,
            pageNum: 0,
            hasLeaderboardData: true,
          };
          try {
            var requestParamsId = JSON.parse(item.searchField);
            if (requestParamsId)
              Object.assign(requestParamsData, requestParamsId);
          } catch (ignore) {
            // do nothing
          }
          var imgAttr = self.getImgAttr(item, IMAGESCONST);
          // var maxImgCount =
          //   Math.floor(
          //     (document.body.clientWidth * 0.9) / (imgAttr.imgWidth + 20)
          //   ) - 1;
          // if (imgAttr.type == "boutique") {
          //   maxImgCount = Math.floor(
          //     (document.body.clientWidth * 0.9 - 532) / (imgAttr.imgWidth + 20)
          //   );
          // }
          self
            .$axios({
              url: "/realNet/video/getVideoInfos",
              method: "get",
              headers: {
                token: "123456789",
              },
              params: requestParamsData,
            })
            .then(function (resp) {
              var contentData = resp.data.result.content;
              var leaderboardContent = resp.data.result.leaderboardContent;

              var contentInfoData = {
                title: item.name,
                type: imgAttr.type,
                icon: require("../assets/icon/" + imgAttr.icon + ".png"),
                list: [],
                isSeniority: item.displayLeaderboard === 1 ? true : false,
                recommendList: [],
                seniorityInfo: {
                  title: "排行榜",
                  icon: require("../assets/icon/imageIcon.png"),
                  type: "name",
                  list: [],
                },
              };
              var seniorityInfoData = {
                title: "排行榜",
                icon: require("../assets/icon/imageIcon.png"),
                type: "name",
                style: {
                  width: "100%",
                  height: "100%",
                },
                list: [],
              };
              if (contentData) {
                contentData.map((listItem, i) => {
                  var thumbImg = listItem.verticalImage;
                  if (
                    (imgAttr.type == "boutique" && i == 0) ||
                    imgAttr.type == "host"
                  ) {
                    thumbImg = listItem.horizontalImage;
                  }

                  if (i < 5) {
                    contentInfoData.list.push({
                      id: listItem.id,
                      img: thumbImg,
                      name: listItem.videoName,
                      intro: listItem.description,
                      grade: listItem.score,
                    });
                  } else {
                    contentInfoData.recommendList.push({
                      id: listItem.id,
                      name: listItem.videoName,
                    });
                  }
                });
                if (leaderboardContent) {
                  leaderboardContent.map((listItem, i) => {
                    if (i < 8) {
                      seniorityInfoData.list.push({
                        id: listItem.id ? listItem.id : "",
                        name: listItem.videoName,
                        grade: listItem.score,
                      });
                    }
                  });
                }
                if (item.usageImage === 1) {
                  seniorityInfoData.list = seniorityInfoData.list.slice(0, 5);
                }
                contentInfoData.seniorityInfo = seniorityInfoData;
                tempData[idx] = contentInfoData;
                if (++tempDataCount == tempData.length)
                  self.templateData = tempData;
              }
            });
        });
      }
    });
  },
  data: function () {
    return {
      bannerImagesData: null,
      loopPlayImagesData: {
        defaultClasses: {
          outerRotateStage: "loopImages",
          rotateStageClass: "loopStage",
          innerShowClass: "loopContainer",
          btnClass: "btnOuter",
          circularClass: "dots",
        },
      },
      bottomBanner: null,
      keyListContentData: null,
      templateData: null,
      key: false,
      //悬浮框显示
      flotationSelect: "",
      bannerImagesData: null,
    };
  },
  methods: {
    initKeyListViewData(data, k) {
      var infoData = {
        type: "",
        title: "电影",
        list: [
          {
            name: "动作",
            target: "",
          },
          {
            name: "爱情",
            target: "",
          },
          {
            name: "科幻",
            target: "",
          },
          {
            name: "惊悚",
            target: "",
          },
        ],
      };

      if (data) {
        infoData.title = data.name ? data.name : "";
        infoData.isRadio = true;
        infoData.list = data.menuList.map((item) => {
          return {
            name: item.name ? item.name : "",
            target: item.url ? item.url : item.searchField,
          };
        });
      }
      return infoData;
    },
    getSeniorityData(data, k) {
      if (data) {
        return data;
      } else {
        return {};
      }
    },
    getImgAttr(item, changObj) {
      var imgAttr = {
        icon: "comedy",
        type: "comedy",
        imgWidth: 192,
      };
      for (var k in changObj) {
        if (item.name.indexOf(k) > -1) {
          imgAttr.icon = changObj[k].icon;
          break;
        }
      }
      if (item.firstImageFeature) {
        imgAttr.type = "boutique";
        imgAttr.imgWidth = 192;
      } else if (item.usageImage == 1) {
        imgAttr.type = "host";
        imgAttr.imgWidth = 256;
      }
      return imgAttr;
    },
    /*关键字列表 点击 ‘更多’ 回调*/
    moreClick(type) {
      this.$router.push({ path: "/search" });
    },
    /*关键字列表 点击类型回调*/
    targetChange(info) {
      this.$router.push({
        path: "/search",
        query: {
          searchField: info[0].searchField,
        },
      });
    },
    /*图片列表 点击“更多”回调*/
    moreContentsClick(info) {
      this.$router.push({
        path: "/special-page",
        query: {
          pageTitle: info.title,
          detailPage: this.getDetailPageName(info.title),
        },
      });
    },
    /*图片列表 点击“电影”回调*/
    movieClick(option) {
      this.$router.push({
        name: this.getDetailPageName(option.info.title),
        query: {
          contentId: option.infoItem.id,
        },
      });
    },
    getDetailPageName(title) {
      if (title.toUpperCase().indexOf("RMHD") > -1) return "DownloadDetailPage";
      return "TVplayPage";
    },
    /* 点击单个类型  参数： item - obj - 单个类型对象 */
    listClick(item) {
      console.log(item);
      var nIdx = this.activeList.indexOf(item.name);

      var callback;

      if (this.isRadio) {
        this.activeName = item.name;
        callback = item;
      } else {
        if (nIdx < 0) {
          this.activeList.push(item.name);
          this.objList.push(item);
        } else {
          this.activeList.splice(nIdx, 1);
          this.objList.splice(nIdx, 1);
        }
        callback = this.objList;
      }
      // 返回 标签类型数组
      this.$emit("targetChange", callback);
    },
    QRcode(data) {
      this.flotationSelect = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.advertisement {
  margin-top: 28px;
  width: 100%;
  a > img {
    width: 100%;
    height: auto;
  }
}
</style>

